import { motion } from "framer-motion";

const ABOUT_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a2c59b25-30f1-4359-838d-3ea682316c82/images/72de34b0d3da61e690922cc318770ee64d93747191d18183e52e6d8df46fa71a.png";

const values = [
  { label: "Precision", text: "Every detail engineered and executed with care." },
  { label: "Trust", text: "Transparent communication, verified teams, full documentation." },
  { label: "Excellence", text: "Certified professionals delivering uncompromising quality." },
  { label: "Sustainability", text: "Eco-conscious methods and materials at every step." },
];

export const About = () => {
  return (
    <section id="about" className="relative py-24 md:py-36 bg-cream" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          {/* Image — sticky on large */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="lg:col-span-5"
          >
            <div className="relative">
              <img
                src={ABOUT_IMG}
                alt="Greenroute precision craftsmanship"
                className="w-full h-[520px] object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-forest text-cream p-6 max-w-[200px]">
                <div className="font-serif text-4xl leading-none">2024</div>
                <div className="uppercase text-[10px] tracking-[0.25em] mt-2 text-cream/70">
                  Year established
                </div>
              </div>
            </div>
          </motion.div>

          {/* Copy */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="uppercase text-xs tracking-[0.3em] text-sage mb-6">
              About Greenroute
            </div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-forest leading-[1.05] tracking-tight">
              A partner who treats your property like an heirloom.
            </h2>
            <div className="divider-line my-10" />
            <p className="text-graphite text-base md:text-lg leading-relaxed max-w-2xl">
              Greenroute Estate Management Services is a South African company providing
              end-to-end repairs, maintenance and management for residential and commercial
              complexes. We serve body corporates, managing agents, estate owners, and
              sectional title schemes — with one trusted point of contact, transparent
              pricing, and full reporting on every job.
            </p>

            {/* Mission / Vision */}
            <div className="grid sm:grid-cols-2 gap-8 mt-12">
              <div className="border-l-2 border-gold pl-6">
                <div className="uppercase text-[10px] tracking-[0.25em] text-sage mb-2">
                  Our Mission
                </div>
                <p className="font-serif text-2xl text-ink leading-snug">
                  To preserve value, ensure safety, and foster thriving communities.
                </p>
              </div>
              <div className="border-l-2 border-gold pl-6">
                <div className="uppercase text-[10px] tracking-[0.25em] text-sage mb-2">
                  Our Vision
                </div>
                <p className="font-serif text-2xl text-ink leading-snug">
                  To be the most trusted estate management partner in South Africa.
                </p>
              </div>
            </div>

            {/* Values */}
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6 mt-14" data-testid="about-values">
              {values.map((v, i) => (
                <motion.div
                  key={v.label}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: i * 0.1 }}
                  className="flex items-start gap-4"
                >
                  <div className="font-serif text-3xl text-gold leading-none">0{i + 1}</div>
                  <div>
                    <div className="font-medium text-ink text-base">{v.label}</div>
                    <div className="text-graphite text-sm mt-1 leading-relaxed">{v.text}</div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
